<template>
  <div id="27_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>
    <v-card>
      <v-card-title>
        Прибуткові накладні
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tablelist"
        :search="search"
        :items-per-page="20"
        dense
      >
        <template v-slot:item.status="{ item }">
          <v-chip :color="getStatusColor(item.status)" >{{ getStatusName(item.status) }}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon v-if="item.deleted" small @click="deleteItem(item)">mdi-delete</v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="nakladnaShow"
      scrollable
    >
      <v-card>
        
        <v-toolbar dense flat dark :color="getStatusColor(nakladnaEditStatus)">
          <v-btn icon dark @click="nakladnaClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> Прибуткова накладна № {{ nakladnaEditNum }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="nakladnaClose()">Закрити</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field label="text" required></v-text-field>
            </v-col>
          </v-row>
        
          <v-data-table
            :headers="nakladnaHeaders"
            :items="nakladnaTablelist"
            dense
            hide-default-footer
          >

          <template v-slot:item.actions="{ item }">
            <v-icon v-if="item.odlon" small @click="nakladnaDeleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:item.tmc="{ item }">
            {{ item.tmc}} 
            
            <v-expand-transition>
              <v-card v-if="item.idrow === nakladnaSnListShow">
                <v-list-item dense v-for="(itemSn, i) in item.snlist" :key="i">
                  <v-list-item-content>
                    <v-list-item-title v-if="itemSn.showCoundat" >{{ itemSn.sn }} = {{ itemSn.coundat }}</v-list-item-title>
                    <v-list-item-title v-else >{{ itemSn.sn }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-expand-transition>

          </template>
          <template v-slot:item.odvim="{ item }">
            {{ item.odvim}} <v-icon v-if="item.snon" @click="clickBarcode(item.idrow)" >mdi-barcode</v-icon>
          </template>

          </v-data-table>
          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="nakladnaClose()">Close</v-btn>
          <v-btn color="blue darken-1" text @click="nakladnaClose()">Save</v-btn>
        </v-card-actions>



      </v-card>
    </v-dialog>
    
    
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        search: '',
        headers: [
          { text: 'Номер', value: 'number', align: 'start' },
          { text: 'Статус' , value: 'status' },
          { text: 'Хто створив', value: 'owner' },
          { text: 'Дата створення', value: 'in_dat' },
          { text: 'Кнтрагент', value: 'contragent' },
          { text: 'Склад', value: 'sklad' },
          { text: '', value: 'actions', sortable: false },
        ],
        tablelist: [],
        nakladnaShow: false,
        nakladnaEditNum: '',
        nakladnaEditStatus: '',
        nakladnaHeaders: [
          { text: '', value: 'actions', sortable: false },
          { text: 'Артикул', value: 'article', align: 'start' },
          { text: 'ТМЦ' , value: 'tmc' },
          { text: 'Кількість', value: 'count' },
          { text: 'Од.Вім.', value: 'odvim' },
          { text: 'Ціна', value: 'price' },
          { text: 'Сума', value: 'sum' },
        ],
        nakladnaTablelist: [],
        nakladnaSnListShow: -1,
        
        

      }
    },
    computed: {

    },
    watch: {
      
    },
    methods: {
      getStatusName (status) {
        if (status == 1) return 'Ok'
        else return 'Не проведена'
      },
      getStatusColor (status) {
        if (status == 1) return 'green'
        else return 'red'
      },
      getTableData () {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '27',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.tablelist = data.tablelist;
            this.progresLineShow = false;
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
          console.error('Error!', error);
        });
      },
      getNakladnaTableData (idn) {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '27',
            ww: '2',
            idn: idn,
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.nakladnaTablelist = data.nakladnaTablelist;
            this.progresLineShow = false;
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
          console.error('Error!', error);
        });
      },
      editItem (item) {
        this.nakladnaShow = true
        this.nakladnaEditNum = item.number
        this.nakladnaEditStatus = item.status
        this.getNakladnaTableData(item.number)
        this.$router.push( { path: '27', query: { idn: item.number } })
        //console.log(this.$route)

      },
      nakladnaClose () {
        this.nakladnaShow = false
        this.nakladnaEditNum = ''
        this.nakladnaEditStatus = ''
        this.nakladnaTablelist = []
      },
      clickBarcode (item) {
        if (this.nakladnaSnListShow === item ) {
          this.nakladnaSnListShow = -1  
        } else {
          this.nakladnaSnListShow = item
        }
      },
      nakladnaDeleteItem (item) {
        console.log(item)
      },



      testPrint: function () {
          window.open(this.$store.getters.apiUrl+"pdf/", "_blank");
      },
    },
    created: function () {
      this.getTableData()
    },
  }
</script>